export const FieldDataType = Object.freeze({
  STRING: 0, // テキスト
  NUMBER: 1, // 数値
  LIST: 2, // リスト
  DATE: 3 // 日付
})



// WEBPACK FOOTER //
// ./src/enums/field-data-type.enums.js